export const DEFAULT_REGION_SPAIN = 'ES_MAIN';
